import Logo from "../logo/Logo";
import styles from "./Header.module.css";
import UserAccount from './../user-account/UserAccount';


const Header = ({ vertical=false, children, rightContent=null, viewMode=false }) => {
    return (
        <header className={`${styles.appHeader} ${viewMode ? styles.viewMode : ''} ${vertical ? styles.appHeaderVertical : ''}`}>
            <Logo size={viewMode ? 'medium' : ''} />
            { children }
            <div>
                { rightContent }
                <UserAccount />
            </div>
        </header>
    )
}

export default Header;